module.exports = __webpack_public_path__ + "static/pregnancy_arabic-06-0620b72fb9c05c94606342cdc57cd166.png";